import { Component, inject, Injector, Input } from '@angular/core';
import { ObjectModel } from "../../../../../models/ObjectModel";
import { ObjectServiceLogModel } from "../../../../../models/ObjectServiceLogModel";
import { TranslateService } from "@ngx-translate/core";
import { AccessRights, UsersService } from 'app/services/users.service';

@Component({
  selector: 'object-servicelog-part',
  templateUrl: './object-servicelog-part.component.html',
  styleUrls: ['./object-servicelog-part.component.css'],
  standalone: false
})
export class ObjectServicelogPartComponent {
  @Input() Object: ObjectModel;
  private translate: TranslateService;
  protected currentItem: number = undefined;

  private usersService = inject(UsersService);
  canEditTrackers: boolean;
  constructor(injector: Injector) {
    this.translate = injector.get(TranslateService);
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }

  getIndex(log: ObjectServiceLogModel): number {
    return this.Object.ServiceLogs.indexOf(log);
  }

  public openAdd() {
    let model = new ObjectServiceLogModel();
    model.ObjectId = this.Object.Id;
    model.Date = new Date().getTime();
    this.Object.ServiceLogs.push(model);
    this.currentItem = this.getIndex(model);
  }

  public deleteLog(model: ObjectServiceLogModel) {
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + model.Value + "?")) return;
    let idx = this.Object.ServiceLogs.indexOf(model);
    if (idx < 0) return;
    this.Object.ServiceLogs.splice(idx, 1);
  }
}
